import React,{ useRef, useState } from "react";
import { useToast } from '@chakra-ui/react';
import axios from "axios";
import {useNavigate} from 'react-router-dom'
import API_URL from "../Api/auction-api";

import emailjs from '@emailjs/browser';

function ForgetPassword() {
  let [otp,setOtp]=useState(0)
  let [userEmail,setUserEmail]=useState(0)
  const [otp2,setOtp2]=useState(0)
  const [email,setEmail]=useState("")
  const [password,setPassword]=useState("")
  const [confirmPassword,setConfirmPassword]=useState("")
  const [show,setShow]=useState(false)



const navigate=useNavigate()
  const form = useRef();
  const toast = useToast();
  const form2=useRef()

  var num;

  //  send email function for otp verification 

  const sendEmail = async () => {
     num=Math.floor(Math.random() * 9000) + 1000;
   
    // otp=num
    await setOtp(num)
   

    emailjs.sendForm('service_zcvuwba', 'template_s0qkxh7', form.current, 'Pt9U39IH8S0QXmCtU')  // using email.js to send email
      .then((result) => {
        toast({
          title:"Otp  will send to ur gmail ",
          description:"please check your gamil and put your otp in bottom input box",
          position: "top-right",
          isClosable: true,
          status: 'success'
        })
       
        setShow(true)
        form.current.reset()
      }, (error) => {
        console.log(error.text);
      });
  };

  // change password and this password updated on database

  async function changePassword(){
   
    const emailpayload={
      email:userEmail
    }
    const payload={
      email:userEmail,
      password:password
    }
    try {
      let res1=await axios.patch(`${API_URL}/forget`,emailpayload)  // email is register or not we have to check first
      
      if(res1.data=="email not registerd"){
        toast({
          title:"email not registerd ",
          description:"Register this email",
          position: "top-right",
          isClosable: true,
          status: 'error'
        })

      }else{

        if(otp==otp2){
          if(password===confirmPassword){
            let res2=await axios.patch(`${API_URL}/forget`,payload)  // email send to respective email to change teir password
        
        toast({
          title:"Password Updated ",
          description:"Please Login Now",
          position: "top-right",
          isClosable: true,
          status: 'success'
        })
        form2.current.reset()
       navigate("/login")

  
        }else{
            toast({
              title:"password not matched ",
              description:"password and confirm password not matched!",
              position: "top-right",
              isClosable: true,
              status: 'error'
            })
  
          }
        
  
        }else{
          toast({
            title:"OTP Not correct",
            description:"Your added otp will not correct please check once",
            position: "top-right",
            isClosable: true,
            status: 'error'
          })
          
        }
      }
    
    } catch (error) {
      console.log(error)
      toast({
        title:"Password not updated ",
        position: "top-right",
        isClosable: true,
        status: 'success'
      })
      
    }

  }




  return (
    <div>
      {!show ? <> <div
        name="Email"
        class="mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8"
      >
        <div class="mx-auto max-w-lg">
          <h1 class="text-center text-2xl font-bold text-indigo-600 sm:text-3xl">
            Don't worry
          </h1>

          <p class="mx-auto mt-4 max-w-md text-center text-gray-500">
            We are here to help you to recover your password. Enter the email
            address you used when you joined and we'll send you OTP to reset
            your password
          </p>

          <form
          
          onSubmit={(e)=>e.preventDefault()}
          ref={form}
            action=""
            class="mb-0 mt-6 space-y-4 rounded-lg p-4 shadow-lg sm:p-6 lg:p-8"
          >
            <p class="text-center text-lg font-medium">Enter your email</p>

            <div>
              <label for="email" class="sr-only">
                Email
              </label>

              <div class="relative">
                <input
                  type="email"
                  class="w-full rounded-lg border-gray-200 p-4 pe-12 text-sm shadow-sm border"
                  placeholder="Enter email"
                  name="user_email"
                  onChange={(e)=>setUserEmail(e.target.value)}
                />
              </div>
            </div>
            <input type="hidden" name="message" value={otp} />

            <button
            onClick={sendEmail}
              type="submit"
              class="block w-full rounded-lg  px-5 py-3 bg-primary  pb-2.5 pt-3 text-sm font-medium uppercase leading-normal text-white bg-blue-500 shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
            >
              submit
            </button>
          </form>
        </div>
      </div> </> : <><div class="mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8">
        <div class="mx-auto max-w-lg">
          <h1 class="text-center text-2xl font-bold text-indigo-600 sm:text-3xl">
            Set new Password
          </h1>

          <form
          ref={form2}
          onSubmit={(e)=>e.preventDefault()}
            action=""
            class="mb-0 mt-6 space-y-4 rounded-lg p-4 shadow-lg sm:p-6 lg:p-8"
          >
            <p class="text-center text-lg font-medium">
              set new password your account
            </p>
            <div>
              <label for="number" class="sr-only">
                Enter OTP here
              </label>

              <div class="relative">
                <input
                  type="number"
                  class="w-full rounded-lg border-gray-200 p-4 pe-12 text-sm shadow-sm border"
                  placeholder="Enter OTP here"
                  onChange={(e)=>setOtp2(e.target.value)}
                />
              </div>
            </div>
            <div>
              <label for="password" class="sr-only">
                Password
              </label>

              <div class="relative">
                <input
                  type="password"
                  class="w-full rounded-lg border-gray-200 p-4 pe-12 text-sm shadow-sm border"
                  placeholder="Enter new password"
                  onChange={(e)=>setPassword(e.target.value)}
                />
              </div>
            </div>
            <div>
              <label for="password" class="sr-only">
                Confirm new password
              </label>

              <div class="relative">
                <input
                  type="password"
                  class="w-full rounded-lg border-gray-200 p-4 pe-12 text-sm shadow-sm border"
                  placeholder="Confirm new password"
                  onChange={(e)=>setConfirmPassword(e.target.value)}
                />
              </div>
            </div>

            <button
              type="submit"
              class="block w-full rounded-lg  px-5 py-3 bg-primary  pb-2.5 pt-3 text-sm font-medium uppercase leading-normal text-white bg-blue-500 shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)]"
            onClick={changePassword}
            >
              submit
            </button>
          </form>
        </div>
      </div>
       </> 
       }
     
    </div>
  );
}

export default ForgetPassword;
